import { render, staticRenderFns } from "./ChatModalKicked.vue?vue&type=template&id=233f778b&"
import script from "./ChatModalKicked.vue?vue&type=script&lang=js&"
export * from "./ChatModalKicked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports